import { Button, Descriptions, Divider, Modal, Table, Spin,message } from '@pankod/refine-antd'
import React, { useRef, useState, useEffect } from 'react'
import { useNavigation } from '@pankod/refine-core'
import { reportDataGenerating } from 'helpers/reportDataGenerating'
import { findCandidateReportDetails } from 'gql/query'

type Show = {
  visible: boolean
  record: any
  hideModal: any
  eval_details: any
}

export const ShowCandidate: React.FC<Show> = ({ visible, record, hideModal, eval_details }) => {
  const inputEl = useRef(null)
  const [isLoading, setLoading] = useState<boolean>(false)
  const columns = () => {
    return [
      { header: 'Id', dataKey: 'id' },
      { header: 'Answers', dataKey: 'answers' },
      { header: 'Remark', dataKey: 'remark' },
      { header: 'Mark Assigned', dataKey: 'mark_assigned' },
      { header: 'Mark Obtained', dataKey: 'mark_obtained' },
    ]
  }
  const [isDownload, setDownload] = useState(false)
  const navigation = useNavigation()
  // Generate the pdf based on a component
  // const printToPdf = () => {
  //   setDownload(true)

  //   let details: object[] = []
  //   details.push({ data: record,eval_details:eval_details})
  //    fetch(`${process.env.REACT_APP_BACKEND_URL}/create-pdf`, {
  //   //  fetch('http://localhost:3001/create-pdf', {
  //     method: 'POST', // *GET, POST, PUT, DELETE, etc.
  //     body: JSON.stringify(details),
  //     headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     console.log("cvvvcc",data?.id,process.env.REACT_APP_NHOST_URL+'/v1/storage/files/')
  //      const objectURL=process.env.REACT_APP_NHOST_URL+'/v1/storage/files/'+data?.id
  //      console.log("objectURL",objectURL)
  //         // const objectURL = URL.createObjectURL(myBlob);
  //         window.open(objectURL, '_blank');
  //         setDownload(false)

  //         // myImage.src = objectURL;
  //       })
  // }
  
  // for generating the report data from view report button
  // const ViewReport = async () => {
  //   setLoading(true)
  //   // console.log(record.answers,"answerss")
  //   const response:any = await reportDataGenerating(record)
  //   console.log(response,record,":response on after valuation")
  //   record.totalMarkofPaper=eval_details?.paper?.product?.total_marks
  //   setLoading(false)
  //   if(!response.error){
  //     const reportData= response
  //     await localStorage.setItem("canReport",JSON.stringify({reportData,record}))
  //     navigation.push('/candidatereport')
  //   }else{
  //     console.log("something went wrong")
  //   }
  // }
  
  // for generating the report data from the db
  const ViewReport = async () => {
    setLoading(true)
    const id= record?.application_id
    if(id){
      setLoading(false)
      navigation.push(`/candidatereport/${id}`)
    } else{
      setLoading(false)
      message.error('Something went wrong')
    }
  }


  console.log("eval_details",eval_details)
  return (
    <Modal title="View Details" visible={visible} onOk={hideModal} onCancel={hideModal} width={1000} centered>
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Candidate Name">{record?.candidate_name}</Descriptions.Item>
        <Descriptions.Item label="Candidate Id">{`#${record?.candidate_id}`}</Descriptions.Item>
        <Descriptions.Item label="Application Id">{`#${record?.application_id}`}</Descriptions.Item>
        <Descriptions.Item label="Total Mark">{eval_details?.paper?.product?.total_marks}</Descriptions.Item>
        <Descriptions.Item label="Correct">{`${record?.correct}`}</Descriptions.Item>
        <Descriptions.Item label="Total Score">{`${record?.total_score}`}</Descriptions.Item>
      </Descriptions>

      <Divider style={{ margin: ' 0', paddingBottom: 5 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <b>Answer Details</b>
        {/* centa */}
        {/* <Button onClick={() => printToPdf()} loading={isDownload}>Download</Button> */}
        <div>
          {isLoading ? (
            <Spin />
          ) : (
            <Button onClick={() => ViewReport()} loading={isDownload}>
              View Report
            </Button>
          )}
        </div>
      </div>
      <div style={{ height: 10 }}></div>
      <Table
        style={{ display: 'inline-block', minWidth: '600px' }}
        id="print_to_pdf"
        ref={inputEl}
        // showHeader={false}
        size="small"
        bordered
        dataSource={record?.answers}
        pagination={false}
        columns={[
          {
            title: 'Id',
            dataIndex: '',
            render: (item, record, index) => <>{record?.key}</>,
            className: record?.status !== undefined ? 'show-row' : 'hide-row',
          },
          {
            title: 'Type',
            dataIndex: '',
            render: (item, record, index) => <>{record?.type}</>,
            className: record?.status !== undefined ? 'show-row' : 'hide-row',
          },
          {
            title: 'Answers',
            dataIndex: 'name',
            className: record?.status !== undefined ? 'show-row' : 'hide-row',
            render: (item, record, index) => (
              <>
                { }
                {record?.type === 'MCQ' ? record?.value : ''}
                {/* {console.log('first', item, record, index)} */}
              </>
            ),
          },
          {
            title: 'Remark',
            dataIndex: 'status',
            className: record?.status !== undefined ? 'show-row' : 'hide-row',
            render: (item, record, index) => <>{record?.status}</>,
          },
          {
            title: 'Mark Assigned',
            dataIndex: 'mark',
            className: record?.status !== undefined ? 'show-row' : 'hide-row',
            render: (item, record, index) => <>{record?.mark}</>,
          },
          {
            title: 'Mark Obtained',
            dataIndex: 'mark_scored',
            className: record?.status !== undefined ? 'show-row' : 'hide-row',
            render: (item, record, index) => <>{record?.mark_scored}</>,
          },
        ]}
       
      />
    </Modal>
  )
}
